var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { t } from 'i18next';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { cancelAppointmentAPI, createJobcardURL, getEstimateListUrl, USER_PROFILE_DATA, ValidateServiceTypeURL } from "../../api/url";
import CancelSuccessfullyPopup from '../../components/molecules/cancelSuccessfullyPopup';
import AppointmentAssignReassignPopup from '../../components/templates/AppointmentAssignReassignPopup';
import CancelDocumentModal from '../../components/templates/cancelDocumentModal';
import { ECancelDocSystemName, EListCardView, EMenuFeature, ESystemName, LOCAL_STORAGE_KEYS, StatusEnum } from "../../constants";
import { setDocDataUpdated, showLoader, showNotification } from "../../redux/commonSlice";
import { createAPI, getListAPI, resetState, setState, updateAPI } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { getCTAList, transactionEventLog } from '../../utils/utils';
import List from "../commonViews/list/list";
var listVariants = ["My Estimate", "All Estimate"];
var ServiceEstimateList = function () {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.crud; }), getEstimateList = _a.getEstimateList, isLoadinggetEstimateList = _a.isLoadinggetEstimateList;
    var _b = useState([]), appointmentList = _b[0], setAppointmentList = _b[1];
    var _c = useState("My Appointments"), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var _d = useState(false), isAssignModalOpen = _d[0], setIsAssignModalOpen = _d[1];
    var _e = useState(""), assignValue = _e[0], setAssignValue = _e[1];
    var _f = useState(false), isRescheduleModalOpen = _f[0], setIsRescheduleModalOpen = _f[1];
    var _g = useState(null), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = useState({}), clickIndexItem = _h[0], setClickIndexItem = _h[1];
    var _j = useState([]), menus = _j[0], setMenus = _j[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var _k = useState(false), cancelPopup = _k[0], setCancelPopup = _k[1];
    var _l = useState(''), estimateCode = _l[0], setEstimateCode = _l[1];
    var _m = useState(false), cancelledSuccessfulPopup = _m[0], setCancelledSuccessfulPopup = _m[1];
    var _o = useState({
        status: [],
        vehicleList: [],
        serviceType: [],
        advisorList: []
    }), filterList = _o[0], setFilterList = _o[1];
    var open = Boolean(anchorEl);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var documentDetailsGetById = useAppSelector(function (state) { return state.crud; }).documentDetailsGetById;
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var serviceEstimateFeatures = getCTAList(storedAllMenuFeatures, "ServiceEstimate");
    // console.log("getEstimateList", getEstimateList?.data?.Key, getEstimateList?.data?.find((f: any) => f.Key === "Created"))
    useEffect(function () {
        dispatch(setDocDataUpdated(false));
    }, []);
    var onClickCreateEstimate = function () {
        var _profileData$data, _profileData$data2, _profileData$data3, _profileData$data4, _profileData$data5, _profileData$data6, _profileData$data7, _profileData$data8, _profileData$data9, _profileData$data10, _profileData$data11, _profileData$data12;
        // mixpanel.track(`create_Estimate` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
        //   'mode': 'Add',
        //   'navigateTo': 'ServiceEstimate Create Page'
        // });
        // window.gtag(
        //   'event', `create_Estimate`, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
        //   'mode': 'Add',
        //   'navigateTo': 'ServiceEstimate Create Page'
        // });
        transactionEventLog("create_Estimate", {
            'id': profileData === null || profileData === void 0 || (_profileData$data = profileData.data) === null || _profileData$data === void 0 ? void 0 : _profileData$data.IdentityId,
            // Transaction ID.
            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data2 = profileData.data) === null || _profileData$data2 === void 0 ? void 0 : _profileData$data2.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data3 = profileData.data) === null || _profileData$data3 === void 0 ? void 0 : _profileData$data3.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data4 = profileData.data) === null || _profileData$data4 === void 0 ? void 0 : _profileData$data4.IdentityId),
            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data5 = profileData.data) === null || _profileData$data5 === void 0 ? void 0 : _profileData$data5.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data6 = profileData.data) === null || _profileData$data6 === void 0 ? void 0 : _profileData$data6.IdentityId),
            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data7 = profileData.data) === null || _profileData$data7 === void 0 ? void 0 : _profileData$data7.IdentityId),
            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data8 = profileData.data) === null || _profileData$data8 === void 0 ? void 0 : _profileData$data8.IdentityId),
            'mode': 'Add',
            'navigateTo': 'ServiceEstimate Create Page'
        }, profileData);
        dispatch(setState({
            key: "EstimateCreateStartTime",
            value: {
                'id': profileData === null || profileData === void 0 || (_profileData$data9 = profileData.data) === null || _profileData$data9 === void 0 ? void 0 : _profileData$data9.IdentityId,
                // Transaction ID.
                'name': (profileData === null || profileData === void 0 || (_profileData$data10 = profileData.data) === null || _profileData$data10 === void 0 ? void 0 : _profileData$data10.GivenName) + (profileData === null || profileData === void 0 || (_profileData$data11 = profileData.data) === null || _profileData$data11 === void 0 ? void 0 : _profileData$data11.FamilyName),
                'code': profileData === null || profileData === void 0 || (_profileData$data12 = profileData.data) === null || _profileData$data12 === void 0 ? void 0 : _profileData$data12.Code,
                'date': new Date(),
                'path': window.location.href
            }
        }));
        // setLocalStorageItem(MODULE_FLOW, { isEstimate: "Create" })
        dispatch(resetState(['AssociateCustomerId', "documentDetailsGetById", "preDocumentFetch", "filterValue", "getCustomerInfo", "getStoredJobItems", "getModuleHeaderCount", "customerComplaintDataImageAndAudio", "customerDetailsTrnalsteToJob", "ModuleDetailsGetById", "additionalEstimateDetail", "savedJobItemCreateFlow"]));
        navigate("/serviceEstimate-create");
    };
    var onClickEstimateCard = function (item) {
        // if (item?.ParentId) {
        //   navigate(`/serviceEstimate-details/${item.EstimateId}/${item.ParentId}`);
        // } else {
        //   navigate(`/serviceEstimate-details/${item.EstimateId}`);
        // }
        // dispatch(setState({ key: "documentDetailsGetById", value: {} }))
        // dispatch(setState({ key: "getCustomerInfo", value: {} }))
        // dispatch(setState({ key: "customerComplaintDataImageAndAudio", value: {} }))
        // dispatch(setState({ key: "getStoredJobItems", value: [] }))
        dispatch(resetState(['AssociateCustomerId', "documentDetailsGetById", "preDocumentFetch", "filterValue", "getCustomerInfo", "getStoredJobItems", "getModuleHeaderCount", "customerComplaintDataImageAndAudio", "customerDetailsTrnalsteToJob", "ModuleDetailsGetById", "additionalEstimateDetail", "savedJobItemCreateFlow"]));
        if (item.Key == EListCardView.ServiceEstimateCreated || item.Key == EListCardView.ServiceEstimateError) {
            var _profileData$data13, _profileData$data14, _profileData$data15, _profileData$data16, _profileData$data17, _profileData$data18, _profileData$data19, _profileData$data20;
            // mixpanel.track(`ServiceEstimate_Card_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': item.EstimateId,
            //   'navigateTo': 'ServiceEstimate Details Created Page'
            // });
            // window.gtag(
            //   'event', `ServiceEstimate_Card_Click`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': item.EstimateId,
            //   'navigateTo': 'ServiceEstimate Details Created Page'
            // });
            transactionEventLog("ServiceEstimate_Card_Click", {
                'id': profileData === null || profileData === void 0 || (_profileData$data13 = profileData.data) === null || _profileData$data13 === void 0 ? void 0 : _profileData$data13.IdentityId,
                // Transaction ID.
                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data14 = profileData.data) === null || _profileData$data14 === void 0 ? void 0 : _profileData$data14.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data15 = profileData.data) === null || _profileData$data15 === void 0 ? void 0 : _profileData$data15.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data16 = profileData.data) === null || _profileData$data16 === void 0 ? void 0 : _profileData$data16.IdentityId),
                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data17 = profileData.data) === null || _profileData$data17 === void 0 ? void 0 : _profileData$data17.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data18 = profileData.data) === null || _profileData$data18 === void 0 ? void 0 : _profileData$data18.IdentityId),
                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data19 = profileData.data) === null || _profileData$data19 === void 0 ? void 0 : _profileData$data19.IdentityId),
                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data20 = profileData.data) === null || _profileData$data20 === void 0 ? void 0 : _profileData$data20.IdentityId),
                'mode': 'Edit',
                'documentId': item.EstimateId,
                'navigateTo': 'ServiceEstimate Details Created Page'
            }, profileData);
            navigate("/serviceEstimate-details-created/".concat(item.EstimateId));
        }
        else {
            var _profileData$data21, _profileData$data22, _profileData$data23, _profileData$data24, _profileData$data25, _profileData$data26, _profileData$data27, _profileData$data28;
            // mixpanel.track(`ServiceEstimate_Card_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': item.EstimateId,
            //   'navigateTo': 'ServiceEstimate Details Page'
            // });
            // window.gtag(
            //   'event', `ServiceEstimate_Card_Click`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': item.EstimateId,
            //   'navigateTo': 'ServiceEstimate Details Page'
            // });
            transactionEventLog("ServiceEstimate_Card_Click", {
                'id': profileData === null || profileData === void 0 || (_profileData$data21 = profileData.data) === null || _profileData$data21 === void 0 ? void 0 : _profileData$data21.IdentityId,
                // Transaction ID.
                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data22 = profileData.data) === null || _profileData$data22 === void 0 ? void 0 : _profileData$data22.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data23 = profileData.data) === null || _profileData$data23 === void 0 ? void 0 : _profileData$data23.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data24 = profileData.data) === null || _profileData$data24 === void 0 ? void 0 : _profileData$data24.IdentityId),
                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data25 = profileData.data) === null || _profileData$data25 === void 0 ? void 0 : _profileData$data25.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data26 = profileData.data) === null || _profileData$data26 === void 0 ? void 0 : _profileData$data26.IdentityId),
                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data27 = profileData.data) === null || _profileData$data27 === void 0 ? void 0 : _profileData$data27.IdentityId),
                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data28 = profileData.data) === null || _profileData$data28 === void 0 ? void 0 : _profileData$data28.IdentityId),
                'mode': 'Edit',
                'documentId': item.EstimateId,
                'navigateTo': 'ServiceEstimate Details Page'
            }, profileData);
            navigate("/serviceEstimate-details/".concat(item.EstimateId));
        }
    };
    var createJobcard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _createJobCardRespons, _createJobCardRespons2, requestBody, _validateServiceTypeR, validateServiceTypeResult, createJobCardResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("documentId-----", clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.EstimateId);
                    requestBody = {
                        EstimateId: clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.EstimateId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    if (!((clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.StatusName) === StatusEnum.Approved)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "serviceTypeValidateData",
                            url: ValidateServiceTypeURL,
                            request: {
                                "VinNo": clickIndexItem.VinNo,
                                "RepairTypeId": clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.RepairTypeId,
                                "Usage": clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.ODOMeterReading,
                                "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                            }
                        }))];
                case 1:
                    validateServiceTypeResult = _a.sent();
                    if ((validateServiceTypeResult === null || validateServiceTypeResult === void 0 || (_validateServiceTypeR = validateServiceTypeResult.payload) === null || _validateServiceTypeR === void 0 || (_validateServiceTypeR = _validateServiceTypeR.value) === null || _validateServiceTypeR === void 0 ? void 0 : _validateServiceTypeR.statusCode) !== 200)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2: return [4 /*yield*/, dispatch(createAPI({
                        key: "",
                        url: createJobcardURL,
                        request: requestBody
                    }))];
                case 3:
                    createJobCardResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (createJobCardResponse !== null && createJobCardResponse !== void 0 && (_createJobCardRespons = createJobCardResponse.payload) !== null && _createJobCardRespons !== void 0 && _createJobCardRespons.success && (createJobCardResponse === null || createJobCardResponse === void 0 || (_createJobCardRespons2 = createJobCardResponse.payload) === null || _createJobCardRespons2 === void 0 ? void 0 : _createJobCardRespons2.statusCode) == 201) {
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: {}
                        }));
                        // mixpanel.track(`Create_Jobcard_Status_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                        //   'date': new Date() + profileData?.data?.IdentityId,
                        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                        //   'mode': 'Edit',
                        //   'documentId': createJobCardResponse.payload.value.data.JobCardId,
                        //   'navigateTo': 'Jobcard Details Page'
                        // });
                        // window.gtag(
                        //   'event', `Create_Jobcard_Status_Click`, {
                        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                        //   'date': new Date() + profileData?.data?.IdentityId,
                        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                        //   'mode': 'Edit',
                        //   'documentId': createJobCardResponse.payload.data.JobCardId,
                        //   'navigateTo': 'Jobcard Details Page'
                        // });
                        navigate("/jobcard-details/".concat(createJobCardResponse.payload.data.JobCardId));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMenusClick = function (data) {
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
        if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.AssignServiceAdvisor) {
            setIsAssignModalOpen(true);
            setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
        }
        else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.Cancel) {
            setCancelPopup(true);
        }
        else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.CreateJobCard) {
            createJobcard();
        }
    };
    var onCancelServiceEstimateClick = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload3;
        return __generator(this, function (_a) {
            if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                dispatch(setState({
                    key: "menuValue",
                    value: 'cancel'
                }));
                onCancelPopupClick(false);
                setEstimateCode((_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.Code);
                setCancelledSuccessfulPopup(true);
            }
            ;
            return [2 /*return*/];
        });
    }); };
    var onCancelAppointmentClick = function (rejectReason, rejectRemark) { return __awaiter(void 0, void 0, void 0, function () {
        var _userData$data, _result$payload4, _result$payload5, request, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        AppointmentCancellationReasonId: rejectReason === null || rejectReason === void 0 ? void 0 : rejectReason.id,
                        CancelBy: userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId,
                        CancelType: 2,
                        CanceledDateTime: clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.ScheduledDate,
                        Remark: rejectRemark
                    };
                    console.log("request-----", request);
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: "cancelAppointment",
                            url: cancelAppointmentAPI(clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.AppointmentId),
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    console.log("resultresultresultresult", result);
                    if ((result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && _result$payload5.success) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Cancelled successfully",
                            type: "success"
                        }));
                        navigate("/appointment");
                        dispatch(setState({
                            key: "menuValue",
                            value: "cancel"
                        }));
                        onCancelPopupClick(false);
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        onCancelPopupClick(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onCancelPopupClick = function (value) {
        setCancelPopup(value);
        setAnchorEl(null);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(List, {
        getModuleList: getEstimateList,
        storeModuleName: "getEstimateList"
        // pageTitle={t("Service estimate")}
        ,
        moduleListUrl: getEstimateListUrl,
        listVariants: listVariants,
        menusFeatures: serviceEstimateFeatures !== null && serviceEstimateFeatures !== void 0 ? serviceEstimateFeatures : []
        // menusFeatures={menus ?? []}
        ,
        onClickCard: onClickEstimateCard,
        onClickCreateModule: onClickCreateEstimate,
        handleMenusClick: handleMenusClick,
        itemData: function (item) { return setClickIndexItem(item); },
        createButtonText: t('Create service estimate'),
        moduleName: ESystemName.Estimate,
        loadingState: isLoadinggetEstimateList,
        noDataTitle: t("No service estimate found"),
        noDataSubTitle: t("No estimate created yet, Please create new estimate."),
        isMoreMenuVisible: false
    }), cancelPopup && /*#__PURE__*/ React.createElement(CancelDocumentModal, {
        cancelPopup: cancelPopup,
        data: clickIndexItem,
        title: t("Cancel service estimate"),
        subTitle: t("Are you sure you want to cancel this estimate? This action cannot be undone."),
        onCancelPopup: function (value) { return onCancelPopupClick(value); },
        onCancelClick: function (result) { return onCancelServiceEstimateClick(result); },
        SystemName: ECancelDocSystemName.Estimate
    }), cancelledSuccessfulPopup && /*#__PURE__*/ React.createElement(CancelSuccessfullyPopup, {
        documentCode: estimateCode,
        successfulPopup: cancelledSuccessfulPopup,
        onClosePopup: function (value) {
            setCancelledSuccessfulPopup(value);
            navigate("/serviceEstimate");
        },
        title: t('Successfully cancelled!'),
        subTitle: "Service estimate ".concat(estimateCode, " has been successfully cancelled")
    }), isAssignModalOpen && /*#__PURE__*/ React.createElement(AppointmentAssignReassignPopup, {
        isOpen: isAssignModalOpen,
        onClosed: function () {
            setIsAssignModalOpen(false);
            setAnchorEl(null);
        },
        data: assignValue,
        appointmentData: clickIndexItem,
        moduleName: EListCardView.ServiceEstimate
    }));
};
export default ServiceEstimateList;
